<div
    [class]="active() ? 'border-primaryLight shadow-none' : 'border-transparent'"
    class="relative flex justify-between items-center xsm:p-4 p-2 rounded-2xl border-2 border-solid shadow-md"
>
    <div class="flex gap-2 items-center">
        <app-tb-icon class="icon-lg" color="textLight" [icon]="icon()"></app-tb-icon>
        <div>
            <div>{{ name() }}</div>
            <div class="caption-1 text-textLight">{{ description() }}</div>
        </div>
    </div>
    <div class="absolute top-[8px] right-[8px] flex items-center gap-2">
        <app-tb-button
            (click)="settings.emit()"
            class="icon-sm"
            icon="custom_settings"
            appearance="icon"
        ></app-tb-button>
        <app-tb-checkbox
            [value]="active()"
            (valueChange)="active.set($event)"
            size="small"
        ></app-tb-checkbox>
    </div>
</div>
